export default () => ({
  requestUrl: null,
  init: function () {
    this.setRequestUrl();
    this.setModalCloseClass();

    this.boundSetRequestUrl = this.setRequestUrl.bind(this);
    this.boundSetModalCloseClass = this.setModalCloseClass.bind(this);
    this.boundEmptyContent = this.emptyContent.bind(this);

    window.addEventListener('hashchange', this.boundSetRequestUrl);
    window.addEventListener('hashchange', this.boundSetModalCloseClass);
    this.$refs.content.addEventListener(
      'htmx:beforeRequest',
      this.boundEmptyContent
    );
  },
  destroy: function () {
    window.removeEventListener('hashchange', this.boundSetRequestUrl);
    window.removeEventListener('hashchange', this.boundSetModalCloseClass);
    this.$refs.content.removeEventListener(
      'htmx:beforeRequest',
      this.boundEmptyContent
    );
  },
  emptyContent: function () {
    this.$refs.content.innerHTML = '';
  },
  setRequestUrl: function () {
    const params = new URLSearchParams(window.location.search);
    if (params.get('country')) {
      this.requestUrl = `/current/country/${params.get('country')}`;
    } else if (params.get('partner')) {
      this.requestUrl = `/current/partner/${params.get('partner')}`;
    }
  },
  setModalCloseClass: function () {
    const modalClose = document.querySelector(
      '.the-current-info-modal .modal-close'
    );
    if (modalClose) {
      const params = new URLSearchParams(window.location.search);
      if (params.get('country')) {
        modalClose.classList.add('text-cw-white');
      } else {
        modalClose.classList.remove('text-cw-white');
      }
    }
  },
});
